import { Button, Modal } from "antd"
import styled from "styled-components"

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    padding: 0;
  }
  
  .ant-modal-header {
    border-bottom: none;
    padding: 24px 24px 0 24px;
  }
  
  .ant-modal-body {
    padding: 16px 24px 24px 24px;
  }
  
  .ant-modal-footer {
    border-top: none;
    padding: 0 24px 24px 24px;
    text-align: right;
  }
`

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 8px 0;
`

export const ModalSubtitle = styled.p`
  font-size: 14px;
  color: #8c8c8c;
  margin: 0 0 24px 0;
  line-height: 1.5;
`

export const DebtList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
  max-height: 500px;
  overflow-y: auto;
`

export const DebtItem = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #2121211F;
  border-radius: 8px;
`

export const IconBarCode = styled.img`
  margin-right: 10px;
`;


export const DebtInfo = styled.div`
  flex: 1;
`

export const DebtDescription = styled.div`
  font-size: 16px;
  color: #212121;
`

export const DebtAmount = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #212121;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`

export const RemoveButton = styled(Button)`
  border-color: #1890ff;
  color: #1890ff;
  
  &:hover {
    border-color: #40a9ff;
    color: #40a9ff;
  }
`

export const CancelButton = styled(Button)`
  background: #1890ff;
  border-color: #1890ff;
  
  &:hover {
    background: #40a9ff;
    border-color: #40a9ff;
  }
`